import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  NgbDropdown,
  NgbDropdownButtonItem,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle,
} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'era-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.scss'],
  imports: [NgbDropdown, FaIconComponent, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem],
})
export class ContextMenuComponent {
  @Input() public isEditing = false;
  @Input() public canEdit = false;
  @Output() public readonly selectedEdit = new EventEmitter();

  public selectEdit() {
    this.selectedEdit.emit();
  }
}
